
"use client";

import { ReportStatus } from "@/types";
import { Badge } from "@/components/ui/badge";
import { Check, Clock, AlertTriangle, X, HelpCircle } from "lucide-react";

interface ReportStatusBadgeProps {
  status: ReportStatus;
}

export function ReportStatusBadge({ status }: ReportStatusBadgeProps) {
  const statusConfig = {
    pending: {
      label: "Pending",
      variant: "outline" as const,
      className: "border-yellow-200 bg-yellow-50 text-yellow-700",
      icon: <Clock className="mr-1 h-3 w-3" />,
    },
    processing: {
      label: "Processing",
      variant: "outline" as const,
      className: "border-blue-200 bg-blue-50 text-blue-700",
      icon: <AlertTriangle className="mr-1 h-3 w-3" />,
    },
    resolved: {
      label: "Resolved",
      variant: "outline" as const,
      className: "border-green-200 bg-green-50 text-green-700",
      icon: <Check className="mr-1 h-3 w-3" />,
    },
    rejected: {
      label: "Rejected",
      variant: "outline" as const,
      className: "border-red-200 bg-red-50 text-red-700",
      icon: <X className="mr-1 h-3 w-3" />,
    },
    invalid: {
      label: "Invalid",
      variant: "outline" as const,
      className: "border-gray-200 bg-gray-50 text-gray-700",
      icon: <HelpCircle className="mr-1 h-3 w-3" />,
    },
  };

  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Badge variant={config.variant} className={config.className}>
      {config.icon}
      {config.label}
    </Badge>
  );
}
